/**
 * Resolve the viewer's IANA timezone for signup date math. The admin dashboard
 * has no user/org timezone override plumbing (unlike aieweb), so we use the
 * browser's resolved timezone, falling back to UTC when unavailable. Week and
 * day boundaries in the KPI cards / chart are computed in this zone.
 */
export function resolveTimezone(): string {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return tz || "UTC";
  } catch {
    return "UTC";
  }
}
